<template>
  <div class="page-container">
    <div class="headbar" :style="{ background: themeColor }">
      <!-- logo -->
      <div class="logo" :style="{ background: themeColor }">
        <div>
          <img src="@/assets/logo_x45.png" />
          <span>淘宝店铺管理专家</span>
        </div>
      </div>
      <div class="version"><span>版本：V3.00</span></div>
    </div>

    <div class="main-content">
      <el-row type="flex" class="func-panel" justify="center">
        <el-col :span="8">
          <div class="init-pic">
            <img src="@/assets/init.png" class="init-pic" />
            <h3>您第一次登陆e店长，请完成用户和系统初始化配置</h3>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="init-process">
            <div class="step">
              <el-steps :active="activeStep" align-center>
                <el-step
                  title="绑定手机号码"
                  icon="fa el-icon-mobile-phone fa-fw fa-2x"
                ></el-step>
                <el-step
                  title="绑定邮箱"
                  icon="fa el-icon-message fa-fw fa-2x"
                ></el-step>
                <el-step
                  title="宝贝同步（耗时久）"
                  icon="fa el-icon-download fa-fw fa-2x"
                ></el-step>
                <el-step
                  title="完成设置"
                  icon="fa el-icon-circle-check fa-fw fa-2x"
                ></el-step>
              </el-steps>
            </div>

            <div v-show="activeStep == 0">
              <el-alert
                class="alert-content"
                title="手机号将作为账户的重要标识，并用于接收系统登陆验证、通知、拦截检测等提醒，请绑定设置！"
                type="warning"
                :closable="false"
                show-icon
              >
              </el-alert>

              <phone-binding
                @handlePhoneBindingDone="handlePhoneBindingDone"
              ></phone-binding>
            </div>

            <!-- 绑定邮箱 -->
            <div v-show="activeStep == 1">
              <el-alert
                class="alert-content"
                title="邮箱用于发送系统通知、库存预警、每日店铺检测报告等，您也可以跳过稍后在各系统功能中绑定"
                type="warning"
                :closable="false"
                show-icon
              >
              </el-alert>
              <email-binding
                @handleEmailBindingDone="handleEmailBindingDone"
                @handleSkip="handleSkip"
                :isSkip="isSkip"
              ></email-binding>
            </div>

            <!-- 商品同步 -->
            <div v-show="activeStep == 2" class="sync">
              <el-alert
                class="alert-content"
                type="warning"
                :closable="false"
                show-icon
              >
                <template slot="title">
                  重要提示：1）同步时间取决于宝贝数量，整个过程约
                  <b style="font-color:red">
                    <u>30分钟，同步未完成相关功能将不可用</u></b
                  >，请您耐心等待。<br />2）同步过程中可关闭浏览器，系统在后台自动同步。（仅第一次登陆需要同步）
                </template>
              </el-alert>

              <sys-sync
                ref="sync"
                :btnName="SyncFinishBtnName"
                :startDirectly="true"
                @handleSyncDone="handleSyncDone"
              ></sys-sync>
              <el-button
                type="primary"
                :loading="oneKeySyncBtnLoading"
                @click="startSync"
                >开始一键同步</el-button
              >
            </div>

            <!-- 完成 -->
            <div v-show="activeStep == 3">
              <el-result
                icon="success"
                title="成功提示"
                subTitle="您已经完成所有初始化设置！"
              >
                <template slot="extra">
                  <el-button type="primary" size="medium" @click="handleAllDone"
                    >进入系统</el-button
                  >
                </template>
              </el-result>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <div>
        <i class="fa fa-gears fa-5x"></i>
        <img src="@/assets/init.png" />
      </div> -->
    </div>

    <!-- </el-card> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import PhoneBinding from "@/views/User/PhoneBinding.vue";
import EmailBinding from "@/views/User/EmailBinding.vue";
import SysSync from "@/views/User/SysSync";

export default {
  components: { PhoneBinding, EmailBinding, SysSync },
  data() {
    return {
      activeStep: 0,
      edzUser: {},
      isSkip: true,
      SyncFinishBtnName: "进入系统",
      oneKeySyncBtnLoading: false
    };
  },
  methods: {
    handlePhoneBindingDone: function(data) {
      this.refreshUserData(data);
      this.activeStep = 1;
    },
    handleEmailBindingDone: function(data) {
      this.refreshUserData(data);
      this.activeStep = 2;
      this.startSync();
    },
    handleSkip: function() {
      this.activeStep = 2;
      this.startSync();
    },
    handleSyncDone: function() {
      this.activeStep = 3;
    },
    handleAllDone: function() {
      this.$router.push({ path: "/" });
    },
    startSync: function() {
      this.oneKeySyncBtnLoading = true;
      //this.$refs.sync.oneKeySync();
      this.$refs["sync"].oneKeySync();
    },
    refreshUserData: function(data) {
      if (data) {
        if ("email" == data.type) {
          this.edzUser.email = data.value;
          this.emailDialogVisible = false;
        } else if ("phoneNo" == data.type) {
          this.edzUser.phoneNo = data.value;
          this.phoneDialogVisible = false;
        }
        //重要，重新属性联系方式
        const edzUserJson = JSON.stringify(this.edzUser);
        sessionStorage.setItem("edzUser", edzUserJson); // 保存用户到本地会话
      }
    }
  },
  mounted() {
    const edzUser = JSON.parse(sessionStorage.getItem("edzUser"));
    if (edzUser) {
      this.edzUser = edzUser;

      if (this.edzUser.phoneNo && this.edzUser.phoneNo != null) {
        this.activeStep = 1;
      }
      if (this.edzUser.email && this.edzUser.email != null) {
        this.activeStep = 2;
      }
    }
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor
    })
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  text-align: center;
  min-width: 1200px;
  .headbar {
    //position: fixed;
    top: 0;
    //right: 0;
    z-index: 1030;
    height: 60px;
    //display: inline;
    line-height: 60px;
    border-color: rgba(180, 190, 190, 0.8);
    border-left-width: 1px;
    border-left-style: solid;
    .logo {
      float: left;
      top: 0px;
      height: 60px;
      //line-height: 60px;
      cursor: pointer;
      width: 300px;
      img {
        // width: 40px;
        height: 38px;
        border-radius: 0px;
        margin: 8px 0px 10px 10px;
        float: left;
      }
      div {
        font-size: 16px;
        color: white;
        span {
          text-align: left;
          font-weight: bold;
          padding-left: 0px;
        }
      }
    }
    .version {
      color: #ffffff;
      padding-top: 0px;
      padding-right: 10px;
      float: right;
      text-align: center;
    }
  }
  .main-content {
    width: 90%;
    margin: 0 auto;
    padding-top: 80px;
    .init-pic {
      padding-right: 20px;
      img {
        width: 400px;
      }
    }
    .step {
      width: 100%;
      padding-top: 20px;
      margin-bottom: 50px;
    }
    .alert-content {
      margin-bottom: 30px;
    }
    .sync {
      padding: 0 40;
      margin: 0 80;
      text-align: left;
      .process-bar {
        padding-bottom: 40px;
      }
      .process-desc {
        text-align: left;
      }
    }
  }
  // .box-card {
  .item-url {
    text-align: center;
    >>> .el-input__inner {
      height: 60px;
      font-size: 1.3em;
    }
  }
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/Init.vue